import { render } from "./NavbarSide.vue?vue&type=template&id=76ce4b7a"
import script from "./NavbarSide.vue?vue&type=script&lang=ts"
export * from "./NavbarSide.vue?vue&type=script&lang=ts"
script.render = render

export default script